var exports = {
  "iE": "xaee3c4fa--d52e4f--wrapper",
  "yx": "xaee3c4fa--d52e4f--post-link",
  "ep": "xaee3c4fa--d52e4f--comment-text",
  "HH": "xaee3c4fa--d52e4f--comment-link",
  "xA": "xaee3c4fa--d52e4f--footnote",
  "HD": "xaee3c4fa--d52e4f--avatars",
  "Dj": "xaee3c4fa--d52e4f--skeleton-avatars",
};

module.exports = exports;
